/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
export * from './textarea.module';
export * from './textarea/textarea.component';
